<template>
  <div
    v-if="isShowSetting"
    class="custom-control custom-checkbox"
  >
    <input
      id="check-participants-name"
      v-model="slideActive.metadata.autoFillParticipantName"
      type="checkbox"
      class="custom-control-input"
      @change="toggleAutofillParticipantNames()"
    >
    <label
      class="custom-control-label"
      for="check-participants-name"
    >{{ $t('Participant name autofill') }}</label>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Socket from '@/socket'
import slideApi from '@/api/slide'

import Utils from '@/util'

// api
import eventCategories from '@/constant/eventCategories'
import EventBus from '@/eventBus'

export default {
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
      sharePresentation: (state) => state.sharePresentation,
    }),
    isShowSetting() {
      return this.slideActive.metadata
        && !this.$store.getters.isPresenting
        && !this.sharePresentation
    },
  },
  created() {
    if (!this.slideActive.metadata) {
      this.updateSlideActiveAction({
        metadata: {},
      })
    }
  },
  methods: {
    async toggleAutofillParticipantNames() {
      const payload = {
        accessCode: this.presentation.uniqueAccessCode,
        metadata: {
          ...this.slideActive.metadata,
          autoFillParticipantName: this.slideActive.metadata.autoFillParticipantName,
        },
        presenting: this.$store.getters.isPresenting,
        socketId: Socket.getSocketId(),
      }
      this.$store.dispatch('setSyncPresentation', 1)
      try {
        await slideApi.updateSlideById(this.slideActive.id, payload)
        const index = this.presentation.slides.findIndex((item) => {
          return item.id === this.slideActive.id
        })
        if (index !== -1) {
          this.presentation.slides[index].metadata = this.slideActive.metadata
        }
        this.$store.dispatch('setSyncPresentation', 2)
      } catch (error) {
        this.$store.dispatch('setSyncPresentation', 3)
      }

      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        `Canvas > Spinner Wheel > Autofill participants' name: ${payload.metadata.autoFillParticipantName}`,
        null,
        null,
        {
          presentationId: this.presentation.id,
          slideId: this.slideActive.id,
        },
      )

      EventBus.$emit('updateEntries')
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-control {
  display: flex;
  align-items: center;
}
</style>
